module.exports = __webpack_public_path__ + "img/攻防演练-bg.166bbbcc.jpg";